import {
  InspectorControlsAppearance,
  InspectorControlsGeneral,
  InspectorTabs,
} from '@components/inspector-tabs';
import Visibility from '@components/visibility';
import ClassDropdown, { getBlockClassNames } from '@components/class-dropdown';
import Label from '@components/block-label';
import { __experimentalNumberControl as NumberControl } from '@wordpress/components';
import {
  DEFAULT_CSS_CLASS,
  DEFAULT_LOGO_SLIDER_SPEED,
  DEFAULT_LOGO_SLIDER_DIRECTION,
} from '@constants';
import {
  useBlockProps,
  MediaUpload,
  MediaUploadCheck,
} from '@wordpress/block-editor';
import classnames from 'classnames';

import './editor.scss';

const {
  i18n: { __ },
  components: { Button, SelectControl, ToggleControl, PanelBody },
} = wp;

const InspectorGeneral = ({ attributes, setAttributes }) => {
  const {
    blockVisibility,
    direction,
    speed,
    label,
    enableCaption,
    logoCountEnableSlider,
  } = attributes;

  return (
    <InspectorControlsGeneral>
      <Label {...{ label, setAttributes }} />
      <Visibility {...{ blockVisibility, setAttributes }} />
      <PanelBody>
        <ToggleControl
          label={__('Show Captions', 'b3rg')}
          checked={enableCaption}
          onChange={(val) => {
            setAttributes({
              enableCaption: val,
            });
          }}
        />
      </PanelBody>
      <PanelBody>
        <SelectControl
          label={__('Moving Direction', 'b3rg')}
          value={direction}
          options={[
            { label: 'Left', value: 'left' },
            { label: 'Right', value: 'right' },
          ]}
          onChange={(val) => {
            setAttributes({
              direction: val,
            });
          }}
        />
        <NumberControl
          label={__('Moving Speed (s)', 'b3rg')}
          min={0}
          value={speed || DEFAULT_LOGO_SLIDER_SPEED}
          onChange={(val) => {
            setAttributes({
              speed: parseInt(val),
            });
          }}
        />
        <NumberControl
          label={__('Logo Count for Enable Slider ', 'b3rg')}
          min={0}
          value={logoCountEnableSlider}
          onChange={(val) => {
            setAttributes({
              logoCountEnableSlider: parseInt(val),
            });
          }}
        />
      </PanelBody>
    </InspectorControlsGeneral>
  );
};

const InspectorAppearance = (props) => {
  const {
    attributes: { blockClassNames },
    setAttributes,
  } = props;
  const defaultBlockCssClass = DEFAULT_CSS_CLASS.LOGO_SLIDER;

  return (
    <InspectorControlsAppearance>
      <ClassDropdown
        {...{
          blockClassNames,
          setAttributes,
          blockClassPrefix: defaultBlockCssClass,
        }}
      />
    </InspectorControlsAppearance>
  );
};

/* Upload Images as logos */

const defaultBlockCssClass = DEFAULT_CSS_CLASS.LOGO_SLIDER;
const ALLOWED_MEDIA_TYPES = ['image'];
const LogoImageUploader = ({ mediaIDs, onSelect }) => {
  return (
    <MediaUploadCheck>
      <MediaUpload
        onSelect={onSelect}
        allowedTypes={ALLOWED_MEDIA_TYPES}
        value={mediaIDs}
        render={({ open }) => (
          <div className={`${defaultBlockCssClass}__btn`}>
            <Button onClick={open} className="button button-large">
              {mediaIDs.length < 1 ? 'Upload / Select Logos' : 'Edit Logos'}
            </Button>
          </div>
        )}
        gallery
        multiple
      />
    </MediaUploadCheck>
  );
};

const Edit = (props) => {
  const { attributes, setAttributes } = props;
  const {
    blockVisibility,
    blockClassNames,
    images,
    direction,
    speed,
    enableCaption,
  } = attributes;
  const defaultBlockDynamicCssClass = `${defaultBlockCssClass}`;
  const classNames = getBlockClassNames(blockClassNames);
  const blockProps = useBlockProps({
    className: classnames({
      [`${defaultBlockCssClass}`]: true,
      [`${defaultBlockDynamicCssClass}`]: defaultBlockDynamicCssClass,
      [`${classNames}`]: classNames,
      disable: !blockVisibility,
    }),
  });

  /* On gallery Images select function */
  const onSelect = (items) => {
    setAttributes({
      images: items.map((item) => {
        return {
          mediaID: parseInt(item.id, 10),
          mediaURL: item.url,
          alt: item.alt,
          title: item.title,
          caption: item.caption,
        };
      }),
    });
  };
  return (
    <>
      <InspectorTabs>
        <InspectorGeneral {...props} />
        <InspectorAppearance {...props} />
      </InspectorTabs>
      <div
        {...blockProps}
        data-direction={direction || DEFAULT_LOGO_SLIDER_DIRECTION}
        data-speed={speed}
      >
        {images.length >= 1 ? (
          <div className={`${defaultBlockCssClass}__wrap`}>
            <ul
              className={`${defaultBlockCssClass}__list`}
              style={{ animationDuration: `${speed}s` }}
            >
              {images.map((item) => {
                const { title, alt, thumbnail, mediaURL, mediaID, caption } =
                  item;
                return (
                  <li key={mediaID}>
                    <div>
                      <img
                        src={thumbnail || mediaURL}
                        alt={alt ? alt : ''}
                        title={title ? title : ''}
                      />
                    </div>
                    {enableCaption && (
                      <div>
                        <p>{caption ? caption : ''}</p>
                      </div>
                    )}
                  </li>
                );
              })}
              ;
            </ul>
          </div>
        ) : (
          <p>
            {__('Please add logos to Logo slider.', 'b3rg')} <br />
            <small>
              {__(
                'Better if you can add Same dimension for all Logo Images.',
                'b3rg',
              )}
            </small>
          </p>
        )}
        <LogoImageUploader
          mediaIDs={images.map((item) => item.mediaID)}
          onSelect={onSelect}
        />
      </div>
    </>
  );
};

export default Edit;
